import React from 'react';

import { useAssistantContext } from 'src/context';
import { MessageDraft } from 'src/features/assistant/action-item/MessageDraft';
import { TaskDraft } from 'src/features/assistant/action-item/TaskDraft';
import history from 'src/history';
import { BillingWidget } from 'src/routes/assistant/BillingWidget';
import { CTA } from 'src/types/stream-chat';

interface ActionItemProps {
  ctas: CTA[];
}

export const ActionItem: React.FC<ActionItemProps> = ({ ctas }) => {
  const { setMessageDraft } = useAssistantContext();

  const handleCTAClick = (cta: CTA) => {
    // parse the type in the cta to find the appropriate app
    // and navigate to the app with the prefilled data. The prefilled
    // data is provided as a json object which should be passed
    // as a query parameter as a "pf" query param.
    let path = '';
    const params = new URLSearchParams();
    switch (cta.type) {
      case 'action.contact_support': {
        path = '/';
        params.set('action', 'contactSupport');
        break;
      }
      case 'action.create_invoice': {
        path = '/invoices/edit';
        break;
      }
      case 'action.send_message': {
        // Handle message draft - don't navigate, just set the draft
        if (
          cta.prefilled_data?.body &&
          typeof cta.prefilled_data.body === 'string'
        ) {
          setMessageDraft(cta.prefilled_data.body);
        }
        return; // Don't navigate for send_message action
      }
      default: {
        if (cta.type.startsWith('action.custom_app.')) {
          const [, , appAction] = cta.type.split('.');
          const { appId } = cta;
          path = '/apps';
          params.set('id', appId);
          params.set('action', appAction ?? '');
        }
        break;
      }
    }

    if (cta.prefilled_data) {
      const encodedData = btoa(JSON.stringify(cta.prefilled_data));
      params.set('pf', encodedData);
    }

    if (path) {
      const nextPath = `${path}?${params.toString()}`;
      history.push(nextPath);
    }
  };

  if (!ctas || ctas.length === 0) {
    return null;
  }

  return (
    <div>
      {ctas.map((cta, index) => (
        <div key={`cta-${index}`}>
          {cta.type === 'action.send_message' ? (
            <MessageDraft cta={cta} handleCTAClick={handleCTAClick} />
          ) : cta.type === 'action.custom_app.create_task' ? (
            <TaskDraft cta={cta} handleCTAClick={handleCTAClick} />
          ) : cta.type === 'action.create_invoice' ? (
            <BillingWidget
              cta={cta}
              onCTAClick={handleCTAClick}
              widgetName="Invoice Draft"
            />
          ) : cta.type === 'action.create_subscription' ? (
            <div>
              <BillingWidget
                cta={cta}
                onCTAClick={handleCTAClick}
                widgetName="Subscription Draft"
                isSubscription
              />
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
};
